import { render, staticRenderFns } from "./xinbox.vue?vue&type=template&id=35df5142&scoped=true&"
import script from "./xinbox.vue?vue&type=script&lang=js&"
export * from "./xinbox.vue?vue&type=script&lang=js&"
import style0 from "./xinbox.vue?vue&type=style&index=0&id=35df5142&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df5142",
  null
  
)

export default component.exports